import type { PartFileStandaloneViewerData } from '@frontend/api';

import type { RootState } from 'store/configureStore';

import { types, type FileViewerAction } from './actions';

export type FileViewerState = {
  activeRootFile?: PartFileStandaloneViewerData | null;
};

const initialState = (): FileViewerState => ({
  activeRootFile: null,
});

const reducer = (state = initialState(), action: FileViewerAction) => {
  switch (action.type) {
    case types.INIT_FILE_VIEWER: {
      const { activeRootFile } = action.payload;
      return {
        ...state,
        activeRootFile,
      };
    }
    case types.UPDATE_ITAR_STATUS: {
      const { isExportControlled } = action.payload;
      return {
        ...state,
        activeRootFile: {
          ...state.activeRootFile,
          isExportControlled,
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;

const getScope = (state: RootState) =>
  state.modules.fileViewer as FileViewerState;

export const getActiveRootFileUuid = (state: RootState) =>
  getScope(state).activeRootFile?.uuid;

export const getActiveRootFile = (state: RootState) =>
  getScope(state).activeRootFile;

export const getActiveRootFileName = (state: RootState) =>
  getScope(state).activeRootFile?.filename;
